import { sportsCategoryConstants } from "../../constants";

export function sportCategories(state = {}, action) {
  switch (action.type) {
    // get all
    case sportsCategoryConstants.GET_ALL_REQUEST:
      return {
        loading: true,
      };
    case sportsCategoryConstants.GET_ALL_SUCCESS:
      return {
        items: action.items,
      };
    case sportsCategoryConstants.GET_ALL_FAILURE:
      return {
        error: action.error,
      };

    // add
    case sportsCategoryConstants.ADD_REQUEST:
      return {
        loading: true,
      };
    case sportsCategoryConstants.ADD_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case sportsCategoryConstants.ADD_FAILURE:
      return {
        error: action.error,
      };

    // update
    case sportsCategoryConstants.UPDATE_REQUEST:
      return {
        loading: true,
      };
    case sportsCategoryConstants.UPDATE_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case sportsCategoryConstants.UPDATE_FAILURE:
      return {
        error: action.error,
      };

    // delete
    case sportsCategoryConstants.DELETE_REQUEST:
      return {
        loading: true,
      };
    case sportsCategoryConstants.DELETE_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case sportsCategoryConstants.DELETE_FAILURE:
      return {
        error: action.error,
      };

    // clear
    case sportsCategoryConstants.CLEAR:
      return {};

    default:
      return state;
  }
}
